'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var react = require('@chakra-ui/react');
require('../../../components/Card/Card.js');
require('../../../components/Card/CardBody.js');
require('../../../components/Card/CardFooter.js');
require('../../../components/Card/CardHeader.js');
require('../../../components/Card/CardHeaderAddon.js');
require('../../../components/Card/CardEditButton.js');
require('../../../components/Card/CardHeaderEditButton.js');
var CardFooterEditButton = require('../../../components/Card/CardFooterEditButton.js');
require('../../../components/Card/CardEmpty.js');
var useEditCard = require('./useEditCard.js');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Edit card header edit button
 *
 * Triggers `onEdit` and switches to the edit state.
 */
var EditCardFooterEditButton = react.forwardRef(function (props, ref) {
  var _useEditCardContext = useEditCard.useEditCardContext(),
    getEditButtonProps = _useEditCardContext.getEditButtonProps;
  return /*#__PURE__*/React__default["default"].createElement(CardFooterEditButton.CardFooterEditButton, getEditButtonProps(props, ref));
});
EditCardFooterEditButton.displayName = 'EditCardFooterEditButton';
exports.EditCardFooterEditButton = EditCardFooterEditButton;